export default __webpack_public_path__ + "static/media/sesame.411048b1.png";